"use client";
import { Title, TableItem } from "../../../components/index.js";

export default function SchoolsSection({
  schoollisting,
  schoolloader,
  schoolloadertxt,
  isMobile,
  shead,
  page,
}) {
  const hasSchools = schoollisting && schoollisting.length > 0;

  return (
    <>
      {/* <Divider /> */}
      <Title
        name={
          page === "city"
            ? "Schools serving this City"
            : "Schools serving this Neighborhood"
        }
        size="medium"
        as="h2"
      />
      <div className="school_tbl">
        {hasSchools ? (
          <div className="school_tbl_main">
            <TableItem
              className="unstackable custom_table"
              color="blue"
              headers={shead}
              items={schoollisting}
            />
          </div>
        ) : (
          schoollisting.length === 0 &&
          schoolloader && (
            <p style={{ textAlign: "Center" }}>{schoolloadertxt}</p>
          )
        )}

        {hasSchools && !isMobile && (
          <div className="school_tbl_sub_txt">
            <div className="school_tbl_sub_txt_left">
              <p>Click links for school listing</p>
              <p>info at GreatSchools.org</p>
            </div>
            <div className="school_tbl_sub_txt_right">
              <p>Houseberry School Score Data</p>
              <p>from CA Dept. of Education</p>
            </div>
          </div>
        )}

        <p className="school_disclaimer">
          Houseberry recommends using these scores as only a starting point, and
          conducting your own investigation into what schools fit best for your
          preferences. School boundaries are not guaranteed and may change. It
          is important to contact the appropriate school district to confirm
          enrollment eligibility before making any decision to move to a
          neighborhood.
        </p>
      </div>
    </>
  );
}
